import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import LearningPage from './pages/LearningPage';
import JobListingsPage from './pages/JobListingsPage';
import JobDetailPage from './pages/JobDetailPage';
import ProfilePage from './pages/ProfilePage';
import ProfileEditPage from './pages/ProfileEditPage';
import ProfileViewPage from './pages/ProfileViewPage';
import PublicProfileSlugPage from './pages/PublicProfileSlugPage';
import ResumeBuilderPage from './pages/ResumeBuilderPage';
import MyResumesPage from './pages/MyResumesPage';
import PublicResumePage from './pages/PublicResumePage';
import ResumePreviewHiddenPage from './pages/ResumePreviewHiddenPage';
import PortfolioPage from './pages/PortfolioPage';
import PortfolioExamplePage from './pages/PortfolioExamplePage';
import PortfolioFilesPage from './pages/PortfolioFilesPage';
import PortfolioPublicViewPage from './pages/PortfolioPublicViewPage';
import AdminDashboard from './pages/AdminDashboard';
import PlatformAnalyticsPage from './pages/PlatformAnalyticsPage';
import MessagingPage from './pages/MessagingPage';
import MyNetworkPage from './pages/MyNetworkPage';
import SettingsPage from './pages/SettingsPage';
import NotFoundPage from './pages/NotFoundPage';
import SecuritySettingsPage from './pages/SecuritySettingsPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import TwoFactorAuthPage from './pages/TwoFactorAuthPage';
import SessionsManagementPage from './pages/SessionsManagementPage';
import OAuthCallbackPage from './pages/OAuthCallbackPage';
import RegisteredUsersPage from './pages/RegisteredUsersPage';

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/auth/callback" element={<OAuthCallbackPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/portfolio/public/:publicLinkId" element={<PortfolioPublicViewPage />} />
        <Route element={<Layout />}>
          <Route path="in/:profileSlug" element={<PublicProfileSlugPage />} />
          <Route path="learning" element={<LearningPage />} />
          <Route path="jobs" element={<JobListingsPage />} />
          <Route path="jobs/:id" element={<JobDetailPage />} />
          <Route path="profile" element={<ProfilePage />} />
          <Route path="profile/view" element={<ProfileViewPage />} />
          <Route path="profile/public/:publicLinkId" element={<ProfilePage />} />
          <Route path="profile/edit" element={<ProfileEditPage />} />
          <Route path="builder" element={<ResumeBuilderPage />} />
          <Route path="builder/:id" element={<ResumeBuilderPage />} />
          <Route path="resume-preview" element={<ResumePreviewHiddenPage />} />
          <Route path="resume-preview/:resumeId" element={<ResumePreviewHiddenPage />} />
          <Route path="resume-preview/public/:publicLinkId" element={<ResumePreviewHiddenPage />} />
          <Route path="my-resumes" element={<MyResumesPage />} />
          <Route path="portfolio" element={<PortfolioPage />} />
          <Route path="portfolio/example" element={<PortfolioExamplePage />} />
          <Route path="portfolio/files" element={<PortfolioFilesPage />} />
          <Route path="messaging" element={<MessagingPage />} />
          <Route path="my-network" element={<MyNetworkPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="admin" element={<AdminDashboard />} />
          <Route path="admin/registered-users" element={<RegisteredUsersPage />} />
          <Route path="platform-analytics" element={<PlatformAnalyticsPage />} />
          <Route path="settings/security" element={<SecuritySettingsPage />} />
          <Route path="settings/security/change-password" element={<ChangePasswordPage />} />
          <Route path="settings/security/two-factor" element={<TwoFactorAuthPage />} />
          <Route path="settings/security" element={<SecuritySettingsPage />} />
          <Route path="settings/security/change-password" element={<ChangePasswordPage />} />
          <Route path="settings/security/two-factor" element={<TwoFactorAuthPage />} />
          <Route path="settings/security/sessions" element={<SessionsManagementPage />} />
          <Route path="settings/security/email" element={<SecuritySettingsPage />} />
          <Route path="settings/security/phone" element={<SecuritySettingsPage />} />
          <Route path="settings/security/passkeys" element={<SecuritySettingsPage />} />
          <Route path="settings/security/devices" element={<SecuritySettingsPage />} />
          <Route path="r/:publicLinkId" element={<PublicResumePage />} />
          <Route path="linkedin-callback" element={<ProfileEditPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default App;
